import { render, staticRenderFns } from "./MovingRingNoData.vue?vue&type=template&id=542fe1dc&"
var script = {}
import style0 from "./MovingRingNoData.vue?vue&type=style&index=0&id=542fe1dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports